import { useCallback, useMemo } from "react";

import { usePagination } from "hooks";
import useRequest from "hooks/useRequest";

const TEMPLATE_CARD_HEIGHT = 200;
const TEMPLATE_CARD_COLUMNS_PER_ROW = 3;
const MODAL_CONTENT_HEIGHT_PERCENTAGE = 0.85;

export function useTemplateQuery(section) {
  const initialPageSize = Math.ceil(
    ((window.innerHeight * MODAL_CONTENT_HEIGHT_PERCENTAGE) /
      TEMPLATE_CARD_HEIGHT) *
      TEMPLATE_CARD_COLUMNS_PER_ROW
  );

  const queryFactory = useCallback(() => {
    const query = `query getTemplates($section: Sections!, $pageSize: Int, $after: String) {
        currentTemplates(section: $section, first: $pageSize, after: $after) {
          edges {
            node {
              id
              current {
                uuid
                title
                about
                numWorkflows
                id
              }
              installed {
                numWorkflows
                title
                about
                id
              }
              publishingName
              faviconUrl
              installableStatus
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `;

    const resolver = ({ data }) => {
      return {
        data: data.currentTemplates.edges.map(({ node }) => {
          return node;
        }),
        pageInfo: data.currentTemplates.pageInfo,
      };
    };

    return { query, resolver };
  }, []);

  const { req } = useRequest(queryFactory);

  return usePagination(req, {
    variables: useMemo(() => {
      return { section };
    }, [section]),
    options: {
      pageSizes: [
        initialPageSize,
        initialPageSize + 12,
        initialPageSize + 30,
        initialPageSize + 51,
      ],
    },
  });
}

export default useTemplateQuery;
